import { Component, Prop, h, Event, EventEmitter, State, Watch } from '@stencil/core';
import { InputFomat } from '../model/input.model';
import { INVAILD_VALUE } from '../constant/dynamic-form-constant';

@Component({
  tag: 'form-input',
  styleUrl: 'form-input.css',
  shadow: false,
})
export class FormInput {
  @Prop({mutable : true}) inputValue: InputFomat;
  @Event() valueChanged: EventEmitter<{ id: string; value: any }>;
   @Prop() resetKey: number;
   @State() currentValue: any;

   componentWillLoad() {
    this.currentValue = this.inputValue.default ?? '';
  }

  @Watch('resetKey')
  onResetKeyChanged() {
    this.currentValue = this.inputValue.default ?? '';
  }

  private ifValidateInput = (target: HTMLInputElement, ifRequire: boolean) => {
    if (!target?.value && ifRequire) {
      target.classList.add('ix-invalid');
    } else {
      target.classList.remove('ix-invalid');
    }
  }

  private handleInput = (event: Event) => {
    const target = event.target as HTMLInputElement;
    const value = this.inputValue.type === 'checkbox' ? target.checked : target.value;
    this.valueChanged.emit({ id: this.inputValue.id, value });
    this.currentValue = value;
    this.ifValidateInput(target, this.inputValue.required);
  };

  private handleArrayInput = (event: Event) => {
    const target = event.target as HTMLInputElement;
    const inputValue = target.value;
    const value = inputValue.split(',').map(value => value.trim());
    this.currentValue = value;
    this.valueChanged.emit({ id: this.inputValue.id, value });
    this.ifValidateInput(target, this.inputValue.required);
  };

  private onInvalid = (id: string) => {
    return INVAILD_VALUE[id] || 'Invalid input';
  }

  render() {
    return (
      <div class="form-box">
        <label htmlFor={this.inputValue.id}>{this.inputValue.label || this.inputValue.id} {this.inputValue.required === true ? '*' : ''}</label>
        <ix-input
          type={this.inputValue.type === 'integer' ? 'number' : this.inputValue.type}
          id={this.inputValue.id}
          min={this.inputValue.min}
          max={this.inputValue.max}
          step={this.inputValue.step}
          value={this.currentValue}
          onInput={this.inputValue.type === 'array' ? (event) => this.handleArrayInput(event) : (event) => this.handleInput(event)}
          placeholder={this.inputValue.label}
          pattern={this.inputValue.pattern}
          onBlur={(event) => this.ifValidateInput(event.target as HTMLInputElement, this.inputValue.required)}
          invalidText={this.onInvalid(this.inputValue.id)}
          helperText ={this.inputValue.helperText}
        />
      </div>
    );
  }
}
//   <input 
//     type={field.type}
//     {...commonProps}
//     min={field.min}
//     max={field.max}
//     step={field.step}
//     style={{ display: field.type === 'hidden' ? 'none' : undefined }}
//   />